import React from 'react';

const Exclusivos = () => {
    return (
        <section className="wrapper style1">
            <div className="container">
                <div id="content">
                    <article>
                        <header>
                            <h2 id="dummy">Bonecos Dummy</h2>
                            <p>A sensação da criançada com o toque especial da GM</p>
                        </header>

                        <span className="image featured">
                            <img src="/images/banner-chess.jpg" alt="Bonecos Dummy" />
                        </span>

                        <p>
                            <strong>Os bonecos Dummy são ferramentas versáteis que estimulam a percepção tátil, o reconhecimento motor e o entendimento anatômico de forma natural e envolvente.</strong>
                        </p>
                        <p>
                            Com formas suaves e proporções pensadas para o toque, eles ajudam no desenvolvimento da coordenação motora, da consciência corporal e da integração sensorial, sendo aliados valiosos em contextos terapêuticos com crianças e adultos.
                        </p>
                        <p>
                            Ao mesmo tempo, funcionam como brinquedos criativos e seguros, que despertam a imaginação e oferecem uma experiência rica de exploração sensorial, mesmo fora do ambiente clínico. Como adicional, criamos uma infinidade de versões com combinações de cores e temas diversos, tornando-os itens altamente colecionáveis.
                        </p>
                        <p>
                            <small style={{ fontSize: '1.1rem' }}>
                                Baseados no modelo original &quot;Dummy 13&quot; de <a href="https://www.printables.com/@soozafone" target="_blank" rel="noopener noreferrer">@soozafone</a>, sob licença CC BY 4.0. Nossos bonecos são versões modificadas, desenvolvidas para proporcionar beleza, maior tamanho e robustez, aliada à segurança ao brincar.
                            </small>
                        </p>

                        <header>
                            <h2 id="puzzles">Puzzles</h2>
                            <p>Encantam crianças e adultos com um toque de nostalgia.</p>
                        </header>

                        <span className="image featured">
                            <img src="/images/banner-chess.jpg" alt="Puzzles Sensoriais" />
                        </span>

                        <p>
                            <strong>Nossa linha de puzzles sensoriais combina inovação, segurança e um toque de nostalgia.</strong>
                        </p>
                        <p>
                            Selecionamos cuidadosamente cada item para garantir experiências seguras tanto para crianças quanto para adultos, sempre com foco em novidades que encantam, desafiam e despertam memórias afetivas.
                        </p>

                        <header>
                            <h2 id="spinners">Spinners</h2>
                            <p>Antiestresse levado à sério</p>
                        </header>

                        <span className="image featured">
                            <img src="/images/banner-chess.jpg" alt="Spinners Antiestresse" />
                        </span>

                        <p>
                            <strong>
                                Nossa coleção de spinners é divertida e funcional, perfeita para todas as idades.
                            </strong>
                        </p>
                        <p>
                            Eles ajudam a combater o estresse, promovendo relaxamento, e auxiliam no desenvolvimento da percepção de movimento e coordenação, especialmente em crianças neurodivergentes.
                        </p>

                        <header>
                            <h2 id="educacional">Auxílio Educacional</h2>
                            <p>Impressão 3D aliada à educação inclusiva.</p>
                        </header>

                        <span className="image featured">
                            <img src="/images/banner-chess.jpg" alt="Auxílio Educacional" />
                        </span>

                        <p>
                            <strong>Nossos itens educacionais foram pensados para tornar o aprendizado mais acessível e interativo.</strong>
                        </p>
                        <p>
                            Oferecemos brinquedos que estimulam a percepção de cores e formas, réguas de apoio à leitura e peças de encaixe que promovem a inclusão e o desenvolvimento cognitivo de forma lúdica.
                        </p>

                        <header>
                            <h2 id="customizados">Customizados</h2>
                            <p>Crie seu material de apoio terapêutico com a gente.</p>
                        </header>

                        <span className="image featured">
                            <img src="/images/banner-chess.jpg" alt="Produtos Customizados" />
                        </span>

                        <p>
                            <strong>Transformamos ideias em experiências educativas incríveis!</strong>
                        </p>
                        <p>
                            Desenvolvemos blocos de cores e formas, réguas de apoio à leitura, itens sensoriais e muito mais.
                            <br />
                            <strong>Vamos criar algo extraordinário juntos?</strong>
                        </p>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default Exclusivos;
